import {Component} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import {Page} from "../flipp-page/Page";

@element("flipp-data-success")
export class CCPAFormSuccess extends Component<{}, void> {
	render() {
		return <Page show="flyers">
			<div class="success-wrapper">
				<div class="success-inner">
					<div class="success-text-wrapper">
						<div class="success-image">
							<img class="myDataSuccess" src="https://f.wishabi.net/creative/Distribution/images/icons/myDataSuccess.svg" alt=""/>
						</div>
						<div class="success-header">{i18n("my_data_confirm_success_header")}</div>
						<div class="success-text">{i18n("my_data_confirm_success_text1")}<br/>{i18n("my_data_confirm_success_text2")}</div>
					</div>
				</div>
			</div>
		</Page>;
	}
}
